
import { ApplicationColor } from '@/entities/Chat/ApplicationColor';
import { ChatPageNavigation } from '@/entities/Chat/ChatPageNavigation';
import { ClientCredential } from '@/entities/Chat/ClientCredential';
import { FetchData } from '@/main';
import { Component, toNative, Vue } from 'vue-facing-decorator';
import { StoreHelper } from '@/store/StoreHelper';
import { Store } from '@/main';
import { AppColorSettingsInfo } from '@/entities/Application/AppColorSettingsInfo';


@Component
class VueIFrame extends Vue {
  private iFrameURL =  process.env.VUE_APP_CHAT;
  private clientCredential: ClientCredential = ClientCredential.createEmpty();
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private defaultTitle = 'Ventla administrative system';
  private changedTitle = 'Ventla Chat and Discussions';
  private mounted() {
  // changr title
    document.title = this.changedTitle;
    window.addEventListener('message',  this.handleMessage);
  }
  private async CreateChatUser() {
    await FetchData('/ApplicationInstance/CreateChatModeratorUser','')
      .then((response: any) => {
        this.clientCredential.EventId = response.EventId;
        this.clientCredential.TeamId = response.Team;
        this.clientCredential.UserToken = response.Token;
        this.clientCredential.UserId = response.User;
        this.clientCredential.EventName = response.EventName;
      })
      .catch(() => {
        // Do nothing
      });
  }

  private handleMessage(ev: any) {
    switch (ev.data.type) {
    case 'GetFontSize':
      this.GetFontSize();
      break;
    case 'GetCredentials':
      setTimeout(() => {
        this.GetCredentials(ev);
      }, 1000);
      break;
    case 'GetColors':
      setTimeout(() => {
        this.GetColors(ev);
      }, 1000);
      break;
    case 'GetPageType':
      setTimeout(() => {
        this.GetPageType(ev);
      } , 1000);
      break;
    case 'PushHandle':
      this.PushHandle();
      break;
    case 'GetLanguage':
      setTimeout(() => {
        this.GetLanguage(ev);
      } , 1000);
      break;
    default:
      break;
    }
  }
  private iframeSrc() {
    return this.iFrameURL;
  }

  private async GetCredentials(ev: any) {
    await this.CreateChatUser();
    // convert into string
    const data = JSON.stringify(this.clientCredential);
    ev.source.postMessage({ type: ev.data.type, data }, ev.origin);
  }

  private GetColors(ev: any) {
    const color: ApplicationColor = ApplicationColor.createEmpty();
    const appColors: AppColorSettingsInfo = this.storeHelper.GetApplicationColorSettingsFromStore();
    // fill color object
    color.TopNavBackgroundColor = appColors.topNavBackgroundColor;
    color.TopNavForegroundColor = appColors.topNavForegroundColor;
    // convert into string
    const data = JSON.stringify(color);
    ev.source.postMessage({ type: ev.data.type, data }, ev.origin);
  }

  private GetPageType(ev: any) {
    const channelPage: ChatPageNavigation = ChatPageNavigation.createEmpty();
    channelPage.EntityId = this.clientCredential.UserId;
    const data = JSON.stringify(channelPage);
    ev.source.postMessage({ type: ev.data.type, data }, ev.origin);
  }
  private PushHandle() {
    // addComment
  }
  private GetFontSize() {
  // add comment
  }
  private GetLanguage(ev: any) {
    // Send default english language
    const data = JSON.stringify('en');
    ev.source.postMessage({ type: ev.data.type, data }, ev.origin);
  }

  // destroy the component and change the title
  private beforeDestroy() {
    document.title = this.defaultTitle;
  }
}
export default toNative(VueIFrame);
